import { useEffect, useState } from 'preact/hooks'
import { OmneoClient } from '../classes/client'
import { OmneoClientWrapper } from '../classes/clientWrapper'

export function useOmneoClient(reloadIfNotLoggedIn) {
  /**
   * @type {[OmneoClientWrapper, Dispatch<StateUpdater<OmneoClientWrapper>>]}
   */
  const [client, setClient] = useState()

  const [reinitialize, setReinitialize] = useState(0)
  const handleSetReinitialize = () => setReinitialize((n) => (n += 1))

  useEffect(() => {
    // eslint-disable-next-line camelcase
    if (reloadIfNotLoggedIn && !global_booking.customer.length) {
      window.location.href = '/#account'
      return
    }
    if (!client) {
      OmneoClient.init().then((client) => {
        const wrapper = new OmneoClientWrapper(client)
        setClient(wrapper)
      })
    }
  }, [client, handleSetReinitialize])

  return { client }
}
